export enum Department {
  KOSMETIK = 'kosmetik',
  OT = 'ot',
}
